<div class="header-container">
    <h1 class="header-title">Tracking Lanes</h1>
    <button class="add-btn" nz-button nzType="primary" nzDanger nzSize="large" (click)="openCreateModal(tplContent, tplFooter)">
        <span nz-icon nzType="plus"></span>
        Add tracking lane
    </button>
</div>
<div class="content">
    <nz-table #laneTable [nzData]="trackingLanes" [nzLoading]="isLoading" [nzFrontPagination]="false">
        <thead>
            <tr>
                <th>Name</th>
                <th>ID</th>
                <th style="max-width: 100px"></th>
            </tr>
        </thead>
        <tbody>
            @for (lane of laneTable.data; track lane.id) {
                <tr>
                    <td>{{ lane.name }}</td>
                    <td>{{ lane.id }}</td>
                    <td>
                        <button nz-button nzType="text" (click)="editTrackingLane(lane)">
                            <span nz-icon nzType="edit" nzTheme="outline"></span>
                        </button>
                        <button nz-button nzType="text" nzDanger (click)="deleteTrackingLane(lane)">
                            <span nz-icon nzType="delete" nzTheme="outline"></span>
                        </button>
                    </td>
                </tr>
            }
        </tbody>
    </nz-table>
</div>

<ng-template #tplContent>
    <form nz-form nzLayout="vertical">
        <nz-form-item>
            <nz-form-label nzRequired>Name</nz-form-label>
            <nz-form-control>
                <input nz-input [(ngModel)]="newLaneName" name="newLaneName" placeholder="Tracking lane name" />
            </nz-form-control>
        </nz-form-item>
    </form>
</ng-template>

<ng-template #tplFooter let-ref="modalRef">
    <button nz-button [disabled]="isCreating" (click)="ref.close()">Cancel</button>
    <button nz-button nzType="primary" [nzLoading]="isCreating" [disabled]="!newLaneName.trim()" (click)="createTrackingLane(ref)">
        Create
    </button>
</ng-template>
